// extracted by mini-css-extract-plugin
export default {"container":"ResultPage_container__BJmOx"};